import { useState } from "react";
import Button from "../../../ui/Button";
import { displayNumber } from "../../../utils/number.utils";
import TablePagination from "../../../ui/Table/TablePagination";
import { displayCarInfo, useGetAllStockListQuery } from "../../../utils/stockList.utils";
import SearchedCarInfo from "./SearchedCarInfo";
import { CloseIcon } from "../../../utils/icon.utils";
import { arrayMap } from "../../../utils/array.utils";

export default function SearchStockList({ step, setStep, onBack }) {
  const pageSize = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [isSearched, setIsSearched] = useState(false);
  const [searchText, setSearchText] = useState(step.carSearch ?? "");

  const { isLoading: loading, data } = useGetAllStockListQuery({
    query: `?page=${currentPage}&size=${pageSize}&chassis=${step.carSearch}`,
    options: {
      enabled: !!step.carSearch
    }
  });

  function hasCarInMultiCars(data) {
    return step?.multiCars?.find((item) => item?.fullChassis === data?.fullChassis);
  }

  function removeCarFromMultiCars(data) {
    return step?.multiCars?.filter((item) => item?.fullChassis !== data?.fullChassis);
  }

  function handleRemoveFromMultiCars(data) {
    setStep((prev) => ({
      ...prev,
      multiCars: removeCarFromMultiCars(data)
    }));
  }

  function handleAddInMultiCars(data) {
    setStep((prev) => ({
      ...prev,
      multiCars: [...prev.multiCars, data]
    }));
  }

  function handleNext(data) {
    if (step.isMultiQuot) {
      if (hasCarInMultiCars(data)) {
        handleRemoveFromMultiCars(data);
      } else {
        handleAddInMultiCars(data);
      }
    } else {
      setStep((prev) => ({
        ...prev,
        currentStep: prev.currentStep + 1,
        car: data
      }));
    }
  }

  function handleMultiNext() {
    setStep((prev) => ({
      ...prev,
      currentStep: prev.currentStep + 1
    }));
  }

  function onSearch() {
    setIsSearched(true);
    setStep((prev) => ({ ...prev, carSearch: searchText }));
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      onSearch();
    }
  };

  const searchLength = data?.data?.length;
  const totalPage = data?.last_page === 1 && data?.total === 0 ? 0 : data?.last_page;

  function handleIsMultiQuot() {
    setStep((prev) => ({ ...prev, isMultiQuot: true }));
  }

  function handleIsSingleQuot() {
    setStep((prev) => ({ ...prev, isMultiQuot: false }));
  }

  const handleNextBtnName = (data) => {
    const isAdd = hasCarInMultiCars(data);
    return step.isMultiQuot ? (!!isAdd ? "Remove" : "Add") : "Next";
  };

  const handleNextBtnColor = (data) => {
    const isAdd = hasCarInMultiCars(data);
    return step.isMultiQuot ? (isAdd ? "danger" : "primary") : "primary";
  };

  return (
    <div>
      {/* search panel */}
      <div>
        <p className="text-center">Car Search From Stock List</p>

        <div className="d-flex gap-3 align-items-center justify-content-center">
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="isMultiQuot"
              id="single"
              checked={!step.isMultiQuot}
              onChange={handleIsSingleQuot}
            />
            <label className="form-check-label" htmlFor="single">
              Single
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              name="isMultiQuot"
              id="multiple"
              checked={step.isMultiQuot}
              onChange={handleIsMultiQuot}
            />
            <label className="form-check-label" htmlFor="multiple">
              Multiple
            </label>
          </div>
        </div>

        <input
          type="text"
          className="form-control text-center"
          placeholder="Enter chassis number"
          onChange={(e) => setSearchText(e.target.value)}
          value={searchText}
          onKeyDown={handleKeyDown}
        />

        <div className="text-center mt-3">
          <Button onClick={onBack} color="info" name={"Back"} />{" "}
          <Button onClick={onSearch} name={loading ? "Searching..." : "Search"} />
        </div>
      </div>

      {/* display mutiple car */}
      {!!step.multiCars.length && step.isMultiQuot && (
        <div className="border rounded p-3 mt-3">
          <p>Quotation for {step.multiCars.length} cars</p>
          <div className="d-flex flex-wrap gap-3">
            {arrayMap(step?.multiCars, (item, index) => (
              <div key={index} className="d-flex align-items-center gap-2">
                <Button
                  onClick={() => handleRemoveFromMultiCars(item)}
                  name={item?.fullChassis ?? ""}
                  icon={CloseIcon}
                  color="danger"
                />
              </div>
            ))}
          </div>

          <div className="text-center mt-3">
            <Button name="Next" onClick={handleMultiNext} />
          </div>
        </div>
      )}

      {!!searchLength && (
        <p style={{ fontWeight: 500 }} className="mt-3">
          <i>{displayNumber(searchLength)} car found from stock list</i>
        </p>
      )}

      {/* search result */}
      {searchLength ? (
        <>
          {arrayMap(data?.data, (item, index) => {
            const carInfo = displayCarInfo(item);
            return (
              <SearchedCarInfo data={carInfo} key={index}>
                <div className="col-12">
                  <div className="text-center">
                    <Button
                      onClick={() => handleNext(carInfo)}
                      name={handleNextBtnName(carInfo)}
                      color={handleNextBtnColor(carInfo)}
                    />
                  </div>
                </div>
              </SearchedCarInfo>
            );
          })}

          <div className="mt-3">
            <TablePagination
              totalPage={totalPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </div>
        </>
      ) : isSearched && !loading ? (
        "No Data"
      ) : (
        ""
      )}
    </div>
  );
}
